import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { EmailVerificationSentLayout } from 'Organisms/EmailVerificationSentLayout';

const FoundationsPaymentCompleted = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <EmailVerificationSentLayout resource={resource} />
  );
};
export { FoundationsPaymentCompleted };
